var _context;

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import * as _ from "../../../util/lodash";
import React from 'react';
import cx from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../../core/hoc";
import { positions, sizes, font, shapes } from "../../../enums";
import Image from "../../core/image";
var ContentItem = createComponent({
  displayName: 'ContentItem',
  propTypes: {
    image: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    topline: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    header: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    byline: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    meta: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    extra: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    actions: PropTypes.element,
    verticalAlign: PropTypes.oneOf(positions.verticalAlign.ALL),
    size: PropTypes.oneOf(_.without(sizes.ALL, sizes.X1)),
    font: PropTypes.shape({
      weight: PropTypes.oneOf(font.weights.ALL),
      family: PropTypes.oneOf(font.families.ALL),
      emphasis: PropTypes.oneOf(font.emphasis.ALL)
    }),
    imageStyles: PropTypes.shape({
      isBordered: PropTypes.bool,
      shape: PropTypes.oneOf(shapes.ALL),
      size: PropTypes.oneOf(_concatInstanceProperty(_context = []).call(_context, sizes.ALL, [null]))
    }),
    id: PropTypes.any,
    isDivided: PropTypes.bool,
    value: PropTypes.any,
    onClick: PropTypes.func,
    isBordered: PropTypes.bool
  },
  defaultProps: {
    image: undefined,
    topline: undefined,
    header: undefined,
    byline: undefined,
    meta: undefined,
    extra: undefined,
    verticalAlign: positions.verticalAlign.MIDDLE,
    size: sizes.M,
    font: defaultFontStyles,
    imageStyles: {
      isBordered: false,
      shape: shapes.ROUNDED,
      size: null
    },
    value: null,
    onClick: undefined,
    id: undefined,
    isDivided: false,
    isBordered: false,
    actions: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  handlers: {
    handleClick: function handleClick(p) {
      return function (e) {
        if (p.onClick) p.onClick(e, {
          value: p.value,
          id: p.id
        });
      };
    }
  },
  render: function render(p) {
    var _cx, _cx2;

    // account for shallow default props
    var _fontStyles = _Object$assign({}, defaultFontStyles, p.font);

    var _mainCx = cx((_cx = {
      'ck content-item': true,
      'content-item--divided': p.isDivided,
      'content-item--inverted': p.isInverted,
      'content-item--clickable': p.onClick
    }, _cx["content-item--align-" + p.verticalAlign] = p.verticalAlign, _cx['content-item--bordered'] = p.isBordered, _cx["content-item--font-" + _fontStyles.family + "-" + _fontStyles.weight] = true, _cx));

    var _contentCx = cx((_cx2 = {
      'content-item-content': true
    }, _cx2["content-item-content--size-" + p.size] = p.size, _cx2["content-item-content--emphasis-" + _fontStyles.emphasis] = true, _cx2));

    return /*#__PURE__*/React.createElement("div", {
      className: _mainCx,
      style: p.style,
      onClick: p.handleClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-item__content-item-inner"
    }, p.image === null ? null : typeof p.image !== 'string' ? /*#__PURE__*/React.createElement("div", {
      className: "content-item__image"
    }, p.image) : /*#__PURE__*/React.createElement("div", {
      className: "content-item__image"
    }, /*#__PURE__*/React.createElement(Image, {
      src: p.image,
      isBordered: p.imageStyles.isBordered,
      size: p.imageStyles.size,
      isCircular: p.imageStyles.shape === shapes.CIRCULAR,
      isRounded: p.imageStyles.shape === shapes.ROUNDED
    })), p.isDivided ? /*#__PURE__*/React.createElement("div", {
      className: "content-item__divider"
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: cx({
        'content-item__right': p.image !== null
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: _contentCx
    }, p.topline ? /*#__PURE__*/React.createElement("div", {
      className: "content-item-content__topline"
    }, p.topline) : null, p.header ? /*#__PURE__*/React.createElement("div", {
      className: "content-item-content__header"
    }, p.header) : null, p.byline ? /*#__PURE__*/React.createElement("div", {
      className: "content-item-content__byline"
    }, p.byline) : null, p.meta ? /*#__PURE__*/React.createElement("div", {
      className: "content-item-content__meta"
    }, p.meta) : null, p.extra ? /*#__PURE__*/React.createElement("div", {
      className: "content-item-content__extra"
    }, p.extra) : null, p.actions ? /*#__PURE__*/React.createElement("div", {
      className: "content-item-actions"
    }, p.actions) : null))));
  }
});
var defaultFontStyles = {
  weight: font.weights.REGULAR,
  family: font.families.CUSTOM,
  emphasis: font.emphasis.NORMAL
};
export var PrivateContentItem = ContentItem;
export default whitelistStyles()(ContentItem);
//# sourceMappingURL=index.js.map